import { Space } from 'antd';
import * as React from 'react';
import CoursesApiService from '../../../api/CoursesApiService';
import Routes from '../../../config/Routes';
import CourseProgramDataTableDTO from '../../../models/CourseProgramDataTableDTO';
import TableRequestDTO from '../../../models/TableRequestDTO';
import BaseDataTableState from '../../../redux/bases/BaseDataTableState';
import BaseFormState from '../../../redux/bases/BaseFormState';
import HistoryUtil from '../../../utils/HistoryUtil';
import TableFilterUtil, { TableFilterOption } from '../../../utils/TableFilterUtil';
import CourseSearch from '../../postSecondary/CourseSearch';
import DataTable, { DataTableColumnProps, FilterType } from '../core/DataTable';
import DataTableButtonUtil from '../core/DataTableButtonUtil';

interface CourseProgramsDataTableProps {
  courseId: string;
  triggerUpdate?: () => void;
}

interface CourseProgramsDataTableState extends BaseDataTableState<CourseProgramDataTableDTO>, BaseFormState {
  showAddCourseModal: boolean | false;
  awardTypes: TableFilterOption[];
  iowaVariations: TableFilterOption[];
}

class CourseProgramsDataTable extends React.Component<CourseProgramsDataTableProps, CourseProgramsDataTableState> {
  private readonly _courseSearchRef = React.createRef<CourseSearch>();

  constructor(props: CourseProgramsDataTableProps) {
    super(props);
    this.state = {
      showAddCourseModal: false,
      awardTypes: [],
      iowaVariations: [],
    };
  }
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps: CourseProgramsDataTableProps) {
    if (prevProps.courseId != this.props.courseId) {
      this.triggerRefresh();
    }
  }

  private fetchData = () => {
    const loaders = [] as any[];

    TableFilterUtil.AwardTypes().then(x => this.setState({ awardTypes: x }));
    TableFilterUtil.IowaVariations().then(x => this.setState({ iowaVariations: x }))

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }


  private openProgram = (record: CourseProgramDataTableDTO) => {
    if (record.programId) {
      HistoryUtil.push(Routes.generate(Routes.PROGRAM_DETAILS, { id: record.programId }, {}), '_blank');
    }
  }

  private _dataTable: DataTable<CourseProgramDataTableDTO> | undefined;

  public triggerRefresh = () => {
    this._dataTable?.refresh();
  }

  private getColumnDefinitions = () => {
    return [
      {
        title: 'Title',
        dataIndex: CourseProgramDataTableDTO.title,
        sorter: true,
        filterType: FilterType.Text,
      },
      {
        title: 'Awards',
        dataIndex: CourseProgramDataTableDTO.awardTypeIds,
        render: (data: string, row: CourseProgramDataTableDTO) => {
          const types = this.state.awardTypes.filter(x => row.awardTypeIds.some(y => y == x.value)).map(x => x.text);
          return types.join(', ');
        },
        filterType: FilterType.DropdownMulti,
        dropdownFilterOptions: this.state.awardTypes,
        width: 225
      },
      {
        title: 'CIP Number ',
        dataIndex: CourseProgramDataTableDTO.cipNumberId,
        render: (data: string, row: CourseProgramDataTableDTO) => {
          if (row.cipNumber?.cipNumberDetails && row.cipNumber?.cipNumberDetails?.length > 0) {
            return row.cipNumber.cipNumberDetails[0].display;
          }
        },
        sorter: true,
        filterType: FilterType.Text,
        width: 225
      },
      {
        title: 'Iowa Variation',
        dataIndex: CourseProgramDataTableDTO.iowaVariationId,
        render: (data: string, row: CourseProgramDataTableDTO) => {

          return row.iowaVariation?.display;
        },
        sorter: true,
        filterType: FilterType.DropdownMulti,
        dropdownFilterOptions: this.state.iowaVariations,
        width: 225
      }
    ] as DataTableColumnProps<any>[];
  };

  render() {
    const actionButtons = [];
    actionButtons.push(DataTableButtonUtil.Reset());

    return (
      <Space direction='vertical' >
        <DataTable
          ref={(element: any) => (this._dataTable = element)}
          onRowClick={this.openProgram}
          serverSide={true}
          tableProps={{
            rowKey: 'id',
            scroll: { x: 500 }
          }}
          globalSearch={true}
          buttonBar={actionButtons}
          columns={this.getColumnDefinitions()}
          fetchData={{
            fetch: (requestState: TableRequestDTO) => CoursesApiService.getCourseProgramsTableData(requestState, this.props.courseId)
          }}
          stateSaving={{ enabled: true, tableUniqueKey: 'course_programs_list' }} />
      </Space>
    );
  }
}

export default CourseProgramsDataTable;
